const createTimer = () => {
    let duration = 0;
    let timerActive = false;
    let intervalId = null;
    let onStopCallback = null;

    const start = () => {
        if (timerActive) return;
        timerActive = true;
        duration = 0; // Reset duration when starting
        intervalId = setInterval(() => {
            duration++;
            // console.log("Duration:", duration, "Sekunden");
        }, 1000);
        console.log("Timer started");
    };

    const stop = () => {
        if (!timerActive) return;
        clearInterval(intervalId);
        timerActive = false;
        console.log("Timer stopped at", duration, "seconds");

        // Call the callback if it exists
        if (onStopCallback) {
            onStopCallback(duration);
        }
        return duration;
    };

    const reset = () => {
        const oldDuration = duration;
        duration = 0;
        console.log("Timer reset");
        return oldDuration;
    };

    const getDuration = () => duration;

    const onStop = (callback) => {
        onStopCallback = callback;
    };

    const isActive = () => timerActive;

    return { start, stop, reset, getDuration, onStop, isActive };
};

export default createTimer;